module.exports = __webpack_public_path__ + "media/网站大屏20240102.e5a4b607.mp4";